import './closeProductModal.css'

const formatDate = (date) => new Date(date).toLocaleString('fr-FR', { timeZone: 'Europe/Paris', dateStyle: 'medium', timeStyle: 'short' });

// Coupons lus dans un term sheet, avant leur création
const CouponsTable = ({ coupons }) => (
  <table className='close_sp_modal_table'>
    <thead>
      <tr><th>#</th><th>Date d'observation</th><th>Rendement</th><th>Montant</th></tr>
    </thead>
    <tbody>
      {coupons.map((coupon, index) => (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{formatDate(coupon.observability_date)}</td>
          <td>{coupon.yield} %</td>
          <td>{coupon.amount} €</td>
        </tr>
      ))}
    </tbody>
  </table>
)

export default CouponsTable
